import { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
	FormControl,
	InputLabel,
	MenuItem,
	CircularProgress,
	Select,
	SelectChangeEvent,
} from "@mui/material";
import { find, map } from "lodash";
import { Device } from "../../../models/Device";
import DeviceApi from "../../../api/device";
import { AppContext } from "../../../Contexts/AppContext";

export default function DevicesSelector(props: {
	reactOnChange: (device: Device | null) => void;
}) {
	const { reactOnChange } = props;
	const [devices, setDevices] = useState<Device[] | []>([]);
	const [selectedDevice, setSelectedDevice] = useState<Device | null>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const { userContext } = useContext(AppContext);
	const reactOnChangeRef = useRef(reactOnChange);

	useEffect(() => {
		reactOnChangeRef.current = reactOnChange;
	}, [reactOnChange]);

	const getDevices = useCallback(async () => {
		if (!userContext?.permissionaryId) {
			setDevices([]);
			setSelectedDevice(null);
			reactOnChangeRef.current(null);
			return;
		}

		setLoading(true);
		try {
			const devices = await DeviceApi.listDevices({
				token: localStorage.getItem("accessToken"),
				query: {
					permissionaryId: userContext.permissionaryId,
				},
			});

			setDevices(devices);
		} catch (error: any) {
			console.error(error);
			setDevices([]);
		} finally {
			setLoading(false);
		}
	}, [userContext?.permissionaryId]);

	useEffect(() => {
		setSelectedDevice(null);
		reactOnChangeRef.current(null);
		getDevices();
	}, [getDevices]);

	return (
		<div style={{ marginBottom: "15px", width: "100%", textAlign: "center" }}>
			{!loading && (
				<FormControl sx={{ m: 1, width: "90%" }} variant='outlined'>
					<InputLabel id='demo-simple-select-label'>
						Seleccione Medidor
					</InputLabel>
					<Select
						labelId='demo-simple-select-label'
						id='demo-simple-select'
						value={selectedDevice ? selectedDevice._id : ""}
						label='Seleccione Medidor'
						defaultValue=''
						onChange={(e: SelectChangeEvent) => {
							const device = find(
								devices,
								(_device: Device) => _device._id === e.target.value
							);

							setSelectedDevice(device ? device : null);
							reactOnChange(device ? device : null);
						}}>
						<MenuItem key={""} value={""}>
							Todos
						</MenuItem>

						{map(devices, (_device: Device) => {
							return (
								<MenuItem key={_device._id} value={_device._id}>
									{_device.deviceId} - {_device.address}
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
			)}
			{loading && <CircularProgress size={25} />}
		</div>
	);
}
